import { PortalMode, LoadStatus } from '@servicetitan/cp-ui';
import classNames from 'classnames';
import { FC } from 'react';
import * as Styles from './grid.module.less';

export interface DashboardGridItemProps<T> {
    mode: PortalMode;
    item: T;
}

export interface DashboardGridEmptyItemProps {
    mode: PortalMode;
}

export interface DashboardGridErrorProps {
    mode: PortalMode;
}

export interface DashboardGridProps<T> {
    mode: PortalMode;
    items: T[];
    component: FC<DashboardGridItemProps<T>>;
    emptyComponent: FC<DashboardGridEmptyItemProps>;
    errorComponent: FC<DashboardGridErrorProps>;
    loadingStatus: LoadStatus;
    scrollMobile?: boolean;
}

export function DashboardGrid<T extends { id: number | string }>({
    component: ItemComponent,
    emptyComponent: EmptyComponent,
    errorComponent: ErrorComponent,
    items,
    loadingStatus: loadingStatus,
    mode,
    scrollMobile,
}: DashboardGridProps<T>) {
    const itemsLimited = (mode.mobile || mode.tablet) && !scrollMobile ? items.slice(0, 2) : items;
    return (
        <div
            className={classNames(Styles.container, {
                [Styles.containedFilled]: items.length,
                [Styles.containerScrollMobile]: scrollMobile,
            })}
        >
            {loadingStatus !== LoadStatus.Error && !items.length && <EmptyComponent mode={mode} />}
            {loadingStatus === LoadStatus.Error && <ErrorComponent mode={mode} />}

            {itemsLimited.map(item => (
                <div key={item.id} className={Styles.card}>
                    <div className={Styles.item}>
                        <ItemComponent mode={mode} item={item} />
                    </div>
                </div>
            ))}
        </div>
    );
}
